module.exports = __webpack_public_path__ + "img/invitation_iamge_functions_en@2x.feb05eef.png";